import { render, staticRenderFns } from "./tempModel.vue?vue&type=template&id=20019843&scoped=true&lang=pug&"
import script from "./tempModel.vue?vue&type=script&lang=js&"
export * from "./tempModel.vue?vue&type=script&lang=js&"
import style0 from "./tempModel.vue?vue&type=style&index=0&id=20019843&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20019843",
  null
  
)

export default component.exports